// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iLsC","colMin":"styles_colMin__3ZynI"};